import {
    Configuration,
    DatasourceControllerApi,
    DatasourceDto,
} from "@inode/pilot-client-typescript-fetch";
import { ApplicationState } from "#store/types";
import { baseCfg } from "#services/pilotService/baseCfg";

export class PilotDatasourceService {
    private readonly api: DatasourceControllerApi;
    private readonly url: string;
    private readonly config: Configuration;
    private readonly userId: string;

    constructor(url: string, userId: string) {
        this.url = url;
        this.userId = userId;
        this.config = new Configuration(baseCfg(url, userId));
        this.api = new DatasourceControllerApi(this.config);
    }

    /**
     * retrieves a list of keys to identify available tables
     */
    list(): Promise<Array<DatasourceDto>> {
        return this.api.listDatasources({
            X_Reference_ID: this.userId,
        });
    }
}
